<div class="mobileVer">
    <section class="content">
      <div class="searchSec">
        <div class="inputSec">
          <form (ngSubmit)="onMasterSearch(true)">
            <input
              type="text"
              class="search-input dp-input-control"
              [formControl]="name"
              placeholder="Search by name"
            />
            <img (click)="onMasterSearch(true)"
              
              src="/assets/master-search-assets/search-dark.png"
              alt=""
            />
          </form>
        </div>
      </div>
    </section>
    <section class="tableSec">
      <!-- <div class="noData" *ngIf="noDataFound">
        <div class="placeholderTable"></div>
        <p>No data found!</p>
      </div> -->
      
      <div class="tableBoxMob" >
        <div class="dataList">
          @if(isLoader){
            <div *ngFor="let i of [].constructor(10)">
              <ul class="eachdataList">
                <li class="data">
                  Sl.No
                  <div class="loader-div"><dp-loader></dp-loader></div>
                </li>
                <li class="data">
                  Status
                  <div class="loader-div"><dp-loader></dp-loader></div>
                </li>
                <li class="data">
                  District
                  <div class="loader-div"><dp-loader></dp-loader></div>
                </li>
                <li class="data">
                  Name
                  <div class="loader-div"><dp-loader></dp-loader></div>
                </li>
                <li class="data">
                  Guardian
                  <div class="loader-div"><dp-loader></dp-loader></div>
                </li>
                <li class="data">
                  Initiation date
                  <div class="loader-div"><dp-loader></dp-loader></div>
                </li>
                <li class="data">
                  Ritwik
                  <div class="loader-div"><dp-loader></dp-loader></div>
                </li>
                <li class="data">
                  Address
                  <div class="loader-div"><dp-loader></dp-loader></div>
                </li>
              </ul>
            </div>
            }
            @else {
              <div
              class="dp-table-scroll"
              infiniteScroll
              [scrollWindow]="false"
              [infiniteScrollDistance]="1"
              [infiniteScrollThrottle]="1000"
              (scrolled)="onScroll()">
              
              @for( lists of responseData; track lists){
                <ul class="eachdataList">
                  <li class="data">
                    Sl.No
                    <span
                     (click)="onCellClick(lists.slNo)"
                      class="serial-no"
                      >{{ lists.slNo }}</span
                    >
                  </li>
                  <li class="data">
                    Status<span>{{ lists.memberStatus }}</span>
                  </li>
                  <li class="data">
                    District <span>{{ lists.district }}</span>
                  </li>
                  <li class="data">
                    Name <span>{{ lists.fullName }}</span>
                  </li>
                  <li class="data">
                    Guardian <span>{{ lists.guardianFullName }}</span>
                  </li>
                  <li class="data">
                    Initiation date <span>{{ lists.initiationDate }}</span>
                  </li>
                  <li class="data">
                    Ritwik <span>{{ lists.ritwik }}</span>
                  </li>
                  <li class="data">
                    Address <span>{{ lists.address }}</span>
                  </li>
                </ul>
                }
              </div>
            }
          
        </div>
      </div>
    </section>
  </div>